export enum MaritalStatus {
    annulled = 'A',
    divorced = 'D',
    domesticPartner = 'T',
    interlocutory = 'I',
    legallySeparated = 'L',
    married = 'M',
    neverMarried = 'S',
    polygamous = 'P',
    unknown = 'UNK',
    unmarried = 'U',
    widowed = 'W',
}
